import request from '@/utils/request'

const baseURL = '/external-requests'

export default {
  // Import external requests/orders
  import(formData) {
    return request({
      url: `${baseURL}/import`,
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  // Search external requests with filters and pagination
  search(params = {}) {
    return request({
      url: baseURL,
      method: 'get',
      params,
    })
  },
  show(id) {
    return request({
      url: `${baseURL}/show/${id}`,
      method: 'get',
    })
  },
  showByCode(code) {
    return request({
      url: `${baseURL}/get-by-code`,
      params: {
        code,
      },
      method: 'get',
    })
  },
  holdAsGisCoordinates(id) {
    return request({
      url: `${baseURL}/hold-as-gis-coordinates/${id}`,
      method: 'post',
    })
  },
  assignCustomer(externalRequestId, payload) {
    return request({
      url: `${baseURL}/assign-customer/${externalRequestId}`,
      method: 'post',
      data: {
        name: payload.name,
        national_id: payload.national_id,
        phone: payload.phone || null,
      },
    })
  },
  unassignCustomer(externalRequestId, customerId) {
    return request({
      url: `${baseURL}/unassign-customer/${externalRequestId}`,
      method: 'post',
      data: {
        customer_id: customerId,
      },
    })
  },
  SerialLetter(id) {
    return request({
      url: `${baseURL}/serial-letter/${id}`,
      method: 'post',
    })
  },
  PrintLetter(id) {
    return request({
      url: `${baseURL}/print-letter/${id}`,
      method: 'post',
    })
  },

  media(id) {
    return request({
      url: `${baseURL}/${id}/media-files`,
      method: 'get',
    })
  },

  uploadAttachments(id, query) {
    return request({
      url: `${baseURL}/${id}/uploadAttachments`,
      method: 'post',
      data: query,
    })
  },

  uploadMultipleAttachments(id, query) {
    return request({
      url: `${baseURL}/${id}/uploadMultipleAttachments`,
      method: 'post',
      data: query,
    })
  },

  exportMissingCriminalReports(governorateId) {
    return request({
      url: `${baseURL}/export/missing-criminal-reports`,
      method: 'get',
      params: { governorate_id: governorateId },
      responseType: 'blob',
      rawResponse: true,
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/json;q=0.9, */*;q=0.8',
      },
    })
  },
}
